module.exports = __webpack_public_path__ + "img/pattern1.311f5c5.svg";